import { render, staticRenderFns } from "./BatchorderCreate.vue?vue&type=template&id=00688500&scoped=true"
import script from "./BatchorderCreate.vue?vue&type=script&lang=js"
export * from "./BatchorderCreate.vue?vue&type=script&lang=js"
import style0 from "./BatchorderCreate.vue?vue&type=style&index=0&id=00688500&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00688500",
  null
  
)

export default component.exports